<template>
  <div class="readable-weektime">
    <div v-for="t in list" :key="t.id">
      <p v-if="t.value">
        <span class="g-tip-text">{{ t.week }}：</span>
        <span>{{ t.value }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array
  }
}
</script>

<style lang="scss" scoped>
.readable-weektime {
  text-align: left;
  line-height: 2.4em;

  p {
    max-width: 625px;
    line-height: 1.4em;
    word-break: break-all;
    margin-bottom: 8px;
  }
}
</style>
